import React, { useEffect, useState } from "react";
import "./OpacitySelector.css";
import Slider from "@mui/material/Slider";
import { styled } from "@mui/material/styles";
import { savedLayers } from "./mapGIS";
import { SliderThumb } from "@mui/material/Slider";

function OpacitySelector({ name, setLayerOpacity }) {
  const [value, setValue] = useState(100);

  // console.log("ekane render to opacity selector", name);

  //This useEffect sets the value thats read when initializing the layer to set it opacity and changes it
  useEffect(() => {
    setLayerOpacity(value);
    console.log(value);
  }, [value]);

  const OpacitySlider = styled(Slider)(({ theme }) => ({
    color: "#64953f", //color of the slider between thumbs
    "& .MuiSlider-thumb": {
      backgroundColor: "#fff", //color of thumbs
    },
    "& .MuiSlider-rail": {
      color: "#64953f", ////color of the slider outside  teh area between thumbs
    },
  }));

  const PrettoSlider = styled(Slider)({
    color: "#64953f",
    height: 3,
    "& .MuiSlider-track": {
      border: "none",
    },
    "& .MuiSlider-thumb": {
      height: 17,
      width: 17,
      backgroundColor: "#fff",
      border: "2px solid currentColor",
      "&:focus, &:hover, &.Mui-active, &.Mui-focusVisible": {
        boxShadow: "inherit",
      },
      "&:before": {
        display: "none",
      },
    },
    "& .MuiSlider-valueLabel": {
      lineHeight: 1.2,
      fontSize: 12,
      background: "unset",
      padding: 0,
      width: 32,
      height: 32,
      borderRadius: "50% 50% 50% 0",
      backgroundColor: "#64953f",
      transformOrigin: "bottom left",
      transform: "translate(50%, -100%) rotate(-45deg) scale(0)",
      "&:before": { display: "none" },
      "&.MuiSlider-valueLabelOpen": {
        transform: "translate(50%, -100%) rotate(-45deg) scale(1)",
      },
      "& > *": {
        transform: "rotate(45deg)",
      },
    },
  });
  /**
   * This function uses the layer name to access an active layer and sets its paint property/opacity to the user selection
   * @param {*} layerOpacity
   */
  const changeOpacity = (layerOpacity) => {
    const layerIndex = savedLayers.findIndex((layer) => layer.Name === name);
    if (layerIndex !== -1) {
      savedLayers[layerIndex].opacity = layerOpacity;
    }
    window.map.setPaintProperty(
      `${name}-layer`,
      "raster-opacity",
      parseFloat(`${layerOpacity}`)
    );
    console.log(`${layerOpacity}`);
  };

  return (
    <PrettoSlider
      valueLabelDisplay="auto"
      aria-label="pretto slider"
      id={`${name}-opacity-slider`}
      defaultValue={value}
      onChange={(changeEvent) => {
        changeOpacity(changeEvent.target.value / 100);
        setValue(changeEvent.target.value);
      }}
    />
  );
}

export default OpacitySelector;
